import { render, staticRenderFns } from "./BoatDetails.vue?vue&type=template&id=45d818f8"
import script from "./BoatDetails.vue?vue&type=script&lang=js"
export * from "./BoatDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports